import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { parseSchema } from '@kirin/api-client/errors';
import { releases } from '@kirin/api-client/contracts';

/**
 * KIR-2962: latest available version per Kirin client (agent / cursor_ext /
 * copilot_ext) from GET /api/releases/latest — resolved backend-side from our
 * GitHub release pipeline (see `latestReleaseSource`). Low-churn, so cached for
 * 30 minutes. Used to flag "update available" against a reported installed
 * version (e.g. the Inventory → Users agent-version cell).
 */
export function useLatestReleases() {
  return useQuery({
    queryKey: ['releases', 'latest'] as const,
    queryFn: async () => {
      const response = await apiClient.get('/releases/latest');
      return parseSchema(releases.releasesLatestSchema, response);
    },
    staleTime: 30 * 60 * 1000,
  });
}
